@file:UseSerializers(InstantIso8601Serializer::class)

package com.ijoin.data.model

import com.ijoin.data.model.serialization.InstantIso8601Serializer
import kotlinx.datetime.Instant
import kotlinx.serialization.Serializable
import kotlinx.serialization.UseSerializers

@Serializable
data class Booking(
    val id: Long,
    val eventId: String? = null,
    val clientId: Long,
    val clientName: String? = null,
    val clientFirstName: String? = null,
    val clientLastName: String? = null,
    val clientEmail: String? = null,
    val serviceProviderId: Long,
    val serviceProviderName: String? = null,
    val timeSlots: List<TimeSlot> = emptyList(),
    val status: BookingStatus,
    val clientNotes: String? = null,
    val providerNotes: String? = null,
    val cancelledAt: Instant? = null,
    val cancellationReason: String? = null,
    val occurrenceDateTime: Instant? = null,
    val createdAt: Instant? = null,
    val updatedAt: Instant? = null,
)

@Serializable
enum class BookingStatus {
    RESERVED,
    PENDING,
    CONFIRMED,
    CANCELLED,
    COMPLETED,
    EXPIRED,
    NO_SHOW,
}
